export enum EHoverEffect {
    UNDEFINED = '',
    TEXTPRIMARY = 'text-primary',
    TEXTSECONDARY = 'text-secondary',
    FADE = 'fade',
}
